export const Media = [
  { type: "video", url: require("./media/0830.mp4") },
  { type: "video", url: require("./media/0830(1).mp4") },
  { type: "video", url: require("./media/0830(3).mp4") },

  {
    type: "video",
    url: require("./media/car.mp4"),
  },
  { type: "video", url: require("./media/ngozi.mp4.mp4") },
  { type: "video", url: require("./media/xmass.mp4") },
  { type: "video", url: require("./media/0830(6).mp4") },
  { type: "video", url: require("./media/0830(5).mp4") },

  // { type: "image", url: require("./media/img-03.jpg") },
  // { type: "video", url: require("./media/video-03.mp4") },
  // // { type: "image", url: require("./media/img-04.jpg") },
  // { type: "video", url: require("./media/video-04.mp4") },
  // { type: "image", url: require("./media/img-05.jpg") },
];
